import React from 'react';
import Text, { H3 } from '@dbk/ui-text';
import PropTypes from 'prop-types';
import uiJson from '../../../../@extension/CH/src/data/ui.json';
import config from '../../../data/settings.json';
import { RM_REGION, EBANKINGWEBLUX, EBANKINGWEBUK } from '../../../constants';
import envConfig from '../../../../db-env-build';


const PdfContent = (props) => {
  const { modalContentType } = props;
  const { i18n: { messages }, languages: { destLanguageCode } } = props;
  const remoteUrl = window.location.origin + config.environments.relative.remoteUrl;
  
  if (modalContentType === 'first-time-login' || modalContentType === 'faq' || modalContentType === 'security' || modalContentType === 'userManual'){
    let url = '';
    let title = '';
    const height = $(window).height() - 300;

    if (modalContentType === 'first-time-login') {
        url = remoteUrl + ((destLanguageCode === 'de-CH') ? uiJson.pdf.firstTimeLoggingInGerman: uiJson.pdf.firstTimeLoggingIn);
    }
    
    if (modalContentType === 'faq') {
      title = messages['app.login.faq'];
      if(envConfig.rmRegion === RM_REGION){
        url = remoteUrl + uiJson.pdf.faq.replace("CH", "LUX");
      }else{
      url = remoteUrl + uiJson.pdf.faq;
      }
    } 
    if (modalContentType === 'security') {
      title = messages['app.login.securityTips'];
      if(envConfig.rmRegion === RM_REGION){
        url = remoteUrl + uiJson.pdf.securityTips.replace("CH", "LUX");
      }else{
      url = remoteUrl + uiJson.pdf.securityTips;
      }
    }

    if (modalContentType === 'userManual') {
      title = messages['app.login.userManual'];
      if(envConfig.rmRegion === RM_REGION || envConfig.envConfig === EBANKINGWEBLUX ){
        if(destLanguageCode === 'de-CH'){
          url = remoteUrl + uiJson.pdf.userManualGerman.replace("CH", "LUX");
        } else {
          url = remoteUrl + uiJson.pdf.userManual.replace("CH", "LUX");
        }
      } else {
        url = remoteUrl + uiJson.pdf.userManual;
      }
    }

    return (
      <div>
        <div className="row">
          {remoteUrl ? (
            <div className="small-12 columns">
              <iframe
                frameBorder="0"
                height={height}
                width="100%"
                src={url}
                allowFullScreen
              />
            </div>
          ) : (
              <div className="small-12 columns">
                <Text>{messages['app.reports.unablePdf']}</Text>
              </div>
            )}
        </div>
      </div>
    );
  }
  return <Text>{messages['app.profile.consolidatesetup.dataRes']}</Text>;
};

PdfContent.propTypes = {
  modalContentType: PropTypes.string,
};

PdfContent.defaultProps = {
  modalContentType: '',
};

export default PdfContent;
